// extracted by mini-css-extract-plugin
export var footerHolder = "Layout-module--footerHolder--b0f32";
export var headerHolder = "Layout-module--headerHolder--63a22";
export var mainHolder = "Layout-module--mainHolder--143a3";
export var siteTitleHolder = "Layout-module--siteTitleHolder--ae6da";
export var subTitleHolder = "Layout-module--subTitleHolder--e1c9e";